
export class AdministrativeCentresModel {
  id: number;
  centreCode: string;
  centreName: string;
  roleTypeCode: string;
}
